var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('master-page',{attrs:{"icone":"mdi-calendar-check","titulo":"Atividades de captação"}},[_c('v-card',{staticClass:"ma-4"},[_c('v-card-title',[_vm._v("Atividades de captação")]),_c('v-card-text',[_c('atividades-crm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }